import React from 'react';

import { LoaderPage, useAuthentication, useI18n } from '@freelancelabs/components';
import { consommerSortie, redirectToApp } from '@freelancelabs/shared';
import { AppName } from '@freelancelabs/shared/lib/apps';

import ApiProvider from '../ApiProvider';
import Pages from '../pages';
import BackofficeGuard from './BackofficeGuard';

const Setup = () => {
    const { isInitialized: isInitializedAuth, hasSession } = useAuthentication();
    const { isInitialized: isInitializedI18n } = useI18n();

    if (!isInitializedAuth || !isInitializedI18n) {
        return <LoaderPage />;
    }

    if (isInitializedAuth && isInitializedI18n && !hasSession) {
        /*
         * LE SEUL CHEMIN DE REDIRECTION VERS `account`, et il porte le motif quand
         * `BackofficeGuard` vient de mettre un client dehors.
         *
         * L'adresse courante ne voyage alors PAS : elle ramenerait la personne se faire
         * sortir une seconde fois.
         */
        const motif = consommerSortie();
        redirectToApp(AppName.ACCOUNT, motif ? { alerte: motif } : { 'redirect-after-login': window.location.href });
        return <LoaderPage />;
    }

    // ApiProvider en dedans de la garde de session : le client Apollo lit le
    // jeton, il n'a rien a faire tant qu'il n'y en a pas.
    return (
        <ApiProvider>
            <BackofficeGuard>
                <Pages />
            </BackofficeGuard>
        </ApiProvider>
    );
};

export default Setup;
